import { render, staticRenderFns } from "./MailingAddress.vue?vue&type=template&id=1a9cdf71"
import script from "./MailingAddress.vue?vue&type=script&lang=js"
export * from "./MailingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MailingAddress.vue"
export default component.exports